import { landingFaq } from '@/data/landing/FaqData'
import { AccordionGroup, AccordionItem } from '@dgshahr/ui-kit/Accordion'

const FaqSection = () => {
  return (
    <section id="faq" className="w-full py-12 tablet:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 tablet:px-6 desktop:px-8">
        <div className="mb-8 text-center">
          <div className="mb-3 inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-600">
            سوالات متداول
          </div>
          <h2 className="text-2xl font-black text-slate-900 tablet:text-3xl">
            پاسخ به سوالات رایج فروشندگان
          </h2>
        </div>

        <div className="mx-auto flex w-full max-w-[900px] flex-col gap-4">
          {landingFaq.map((faqItem) => (
            <AccordionGroup className="w-full" key={faqItem.id} disableAccordion>
              <AccordionItem
                className="relative w-full rounded-[22px] border border-slate-200 bg-white p-2 shadow-[0_12px_30px_rgba(15,23,42,0.04)]"
                title={faqItem.title}
                titleClassName="!text-right !text-base !font-bold !text-slate-800"
              >
                <div className="px-2 pb-2 text-right text-sm leading-7 text-slate-600">
                  {faqItem.body}
                </div>
              </AccordionItem>
            </AccordionGroup>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FaqSection
